import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4">
      <h1 className="mb-2 text-6xl font-bold text-gray-300">404</h1>
      <p className="mb-6 text-lg text-gray-500">페이지를 찾을 수 없습니다.</p>
      <Link
        to="/"
        className="rounded-lg bg-primary-600 px-6 py-2 text-white hover:bg-primary-700"
      >
        홈으로 돌아가기
      </Link>
    </div>
  );
}
